import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import '@/App.css';
import { AuthProvider } from '@/lib/AuthContext';
import { CartProvider } from '@/lib/CartContext';
import Layout from '@/components/Layout';
import MobileCartBar from '@/components/MobileCartBar';
import ProtectedRoute from '@/components/ProtectedRoute';
import ScrollToTop from '@/components/ScrollToTop';
import Home from '@/pages/Home';
import Apply from '@/pages/Apply';
import Login from '@/pages/Login';
import Catalog from '@/pages/Catalog';
import ProductDetail from '@/pages/ProductDetail';
import Cart from '@/pages/Cart';
import Dashboard from '@/pages/Dashboard';
import Admin from '@/pages/Admin';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import PublicCatalog from '@/pages/PublicCatalog';
import PublicProductDetail from '@/pages/PublicProductDetail';
import ResetPassword from '@/pages/ResetPassword';
import OrderDetail from '@/pages/OrderDetail';
import PaymentSuccess from '@/pages/PaymentSuccess';
import PaymentCancel from '@/pages/PaymentCancel';

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <CartProvider>
          <ScrollToTop />
          <Toaster position="top-center" richColors />
          <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/apply" element={<Apply />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/orders/:id" element={
              <ProtectedRoute><OrderDetail /></ProtectedRoute>
            } />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/products" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
            <Route path="/products/:sku" element={<ProtectedRoute><ProductDetail /></ProtectedRoute>} />
            {/* Legacy aliases */}
            <Route path="/catalog" element={<ProtectedRoute><Catalog /></ProtectedRoute>} />
            <Route path="/product/:id" element={<ProtectedRoute><ProductDetail /></ProtectedRoute>} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/c/:slug" element={<PublicCatalog />} />
            <Route path="/c/:slug/p/:sku" element={<PublicProductDetail />} />
            <Route path="/cart" element={<ProtectedRoute requireActive><Cart /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <MobileCartBar />
        </CartProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}
